import * as React from "react";
import { useState, useEffect } from "react";
import { Box, Checkbox, CircularProgress,FormControlLabel, FormGroup } from "@mui/material";

interface FilterItem {
  label: string;
  selected: boolean;
}

interface FilterData {
  licenses: FilterItem[];
}

const filterData: FilterData = {
  licenses: [
    { label: "Premium", selected: false },
    { label: "Free", selected: false },
  ],
};
interface Props {
  setProductList?: any;
  productList?: any;
  handleChangeActiveFilters?: any;
  setActiveFilters?: any;
  activeFilters?: any;
}

const LicenseFiltersPage: React.FC<Props> = ({
  handleChangeActiveFilters,
  setActiveFilters,
  activeFilters,
  setProductList,
  productList,
}) => {
  const [isTitleSelected, setIsTitleSelected] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);

  const [selectedFilterData, setSelectedFilterData] = useState<FilterData>({
    ...filterData,
  });

  const handleCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const updatedFilterData = {
      ...selectedFilterData,
      licenses: selectedFilterData.licenses.map((item, i) =>
        i === index ? { ...item, selected: event.target.checked } : item
      ),
    };
    setSelectedFilterData(updatedFilterData);

    // Update active filters based on checked licenses
    const licenseLabels = updatedFilterData.licenses
      .filter((item) => item.selected)
      .map((item) => item.label);

    setActiveFilters((prev: any) => ({
      ...prev,
      licenses: licenseLabels,
    }));

    // Save to local storage
    localStorage.setItem(
      "licenseFilters",
      JSON.stringify(updatedFilterData.licenses)
    );
  };

  useEffect(() => {
    const storedLicenses = localStorage.getItem("licenseFilters");
    if (storedLicenses) {
      const licenses = JSON.parse(storedLicenses);
      setSelectedFilterData({ licenses });

      // Update active filters with only checked licenses
      const licenseLabels = licenses
        .filter((item: any) => item.selected)
        .map((license: any) => license.label);

      setActiveFilters((prev: any) => ({
        ...prev,
        licenses: licenseLabels,
      }));
    } else {
      const licensesInitialData = { licenses: filterData.licenses };
      // If no stored licenses, set default values or fetch from API
      setSelectedFilterData(licensesInitialData);

      localStorage.setItem(
        "licenseFilters",
        JSON.stringify(licensesInitialData.licenses)
      );
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    // Check if all licenses are selected to update Title checkbox
    const allSelected = selectedFilterData.licenses.every(
      (item) => item.selected
    );
    setIsTitleSelected(allSelected);
  }, [selectedFilterData.licenses]);
  return (
    <>
      <Box
        sx={{
          borderBottom: "1px solid #282828",
          minHeight: "50px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "0px 24px",
          mb: "12px",
          pt: "16px",
          pb: "16px",
        }}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={isTitleSelected}
              onChange={(event) => {
                const isChecked = event.target.checked;
                setIsTitleSelected(isChecked);

                const updatedFilterData = {
                  ...selectedFilterData,
                  licenses: selectedFilterData.licenses.map((item) => ({
                    ...item,
                    selected: isChecked,
                  })),
                };
                setSelectedFilterData(updatedFilterData);

                // Update activeFilters based on the Title checkbox state
                const licenseLabels = isChecked
                  ? updatedFilterData.licenses.map((item) => item.label)
                  : [];
                setActiveFilters((prev: any) => ({
                  ...prev,
                  licenses: licenseLabels,
                }));

                // Save to local storage
                localStorage.setItem(
                  "licenseFilters",
                  JSON.stringify(updatedFilterData.licenses)
                );
              }}
              sx={{
                width: "24px",
                height: "24px",
                borderRadius: "6px",
                padding: "4px",
                border: isTitleSelected ? "" : "1px solid #3D3D3D",
                "&.MuiCheckbox-root": {
                  color: "#1b1b1b",
                },
                "&.Mui-checked": {
                  color: "#CF0",
                  borderRadius: "6px",
                  "& .MuiSvgIcon-root": { fontSize: 28 },
                },
              }}
            />
          }
          label="Title"
          labelPlacement="start"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            margin: 0,
            padding: 0,
            fontSize: "16px",
            fontWeight: 500,
            color: isTitleSelected ? "#FFFFFF" : "#8D8D8D",
          }}
        />
      </Box>
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "75%",
          }}
        >
          <CircularProgress
            size={24}
            sx={{
              color: "white",
            }}
          />
        </Box>
      ) : (
        <Box sx={{ maxHeight: "100vh", marginX: "24px" }}>
          <FormGroup
            sx={{ display: "flex", flexDirection: "column", gap: "4px" }}
          >
            {selectedFilterData.licenses.map((item, index) => (
              <>
                <Box
                  key={index}
                  sx={{
                    // borderBottom: "1px solid rgba(255, 255, 255, 0.06)",
                    height: "50px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={item.selected}
                        onChange={(event) => handleCheckboxChange(event, index)}
                        sx={{
                          width: "24px",
                          height: "24px",
                          borderRadius: "6px",
                          padding: "4px",
                          // backgroundColor: item.selected ? "black" : "transparent",
                          border: item.selected ? "" : "1px solid #3D3D3D",
                          "&.MuiCheckbox-root": {
                            color: "#1b1b1b",
                          },
                          "&.Mui-checked": {
                            color: "#CF0",
                            //   backgroundColor: "#CF0",
                            borderRadius: "6px",
                            "& .MuiSvgIcon-root": { fontSize: 28 },
                          },
                        }}
                      />
                    }
                    label={item.label}
                    labelPlacement="start"
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                      margin: 0,
                      padding: 0,
                      fontSize: "16px",
                      lineHeight: "22px",
                      fontWeight: 400,
                      color: "#FFFFFF",
                    }}
                  />
                </Box>
                {index < selectedFilterData.licenses.length - 1 ? (
                  <Box
                    sx={{
                      width: "100%",
                      height: "1px",
                      bgcolor: "rgba(255, 255, 255, 0.06)",
                    }}
                  ></Box>
                ) : null}
              </>
            ))}
          </FormGroup>
        </Box>
      )}
    </>
  );
};

export default LicenseFiltersPage;
